import merge from 'deepmerge';
import Validator from './validator.abstract';
import Message from './message';
import * as helpers from '../../../helpers';

class ChildIndenticalValidator extends Validator {
    constructor(el, submitButton, options = {}, validatorsArray) {
        const mergedOptions = merge({
            defaultErrorText: 'Cet enfant a déjà été ajouté dans ce formulaire, merci'
            + ' de compléter soit en ajoutant un nouvel enfant soit en supprimant cet enfant',
            classList: {
                fieldError: 'is-error-child',
            },
        }, options);
        
        super(el, submitButton, mergedOptions);
        this.blocksToValidate = validatorsArray;
    }


    init() {
        this.changeEventName = 'blur';

        this.getDOMElements();
        super.init();
    }

    getDOMElements() {
        this.childBlockId = this.field.getAttribute('id');
        this.messageId = `message-${this.childBlockId}`;
        this.messageText = this.field.getAttribute('data-message-text');
        this.childBlockNom = this.field.querySelector('.js-child-nom');
        this.childBlockPrenom = this.field.querySelector('.js-child-prenom');
        this.childBlockDate = this.field.querySelector('.js-child-date');
        this.allFields = [this.childBlockNom, this.childBlockPrenom, this.childBlockDate];
        this.form = this.childBlockNom.form;
    }

    _initChangeEventListener(changeEventType) {
        this.allFields.forEach((field) => {
            field.addEventListener(changeEventType, this.$handleFieldChange);
        });
    }

    _removeChangeEventListener(changeEventType) {
        this.allFields.forEach((field) => {
            field.removeEventListener(changeEventType, this.$handleFieldChange);
        });
    }

    manageClasses() {
        const { defaultFieldError, fieldError } = this.options.classList;

        this.allFields.forEach((field) => {
            helpers.addClass(field, fieldError);
            helpers.addClass(field, defaultFieldError);
        });
    }

    removeClasses() {
        const { fieldError, defaultFieldError } = this.options.classList;

        this.allFields.forEach((field) => {
            helpers.removeClass(field, fieldError);

            if (!helpers.hasClass(field, 'is-error-date')) {
                helpers.removeClass(field, defaultFieldError);
            }
        });
    }

    addError() {
        const { defaultErrorText } = this.options;

        Message.addErrorToBlock(this.customErrorText || defaultErrorText, this.messageId, this.field);
    }

    removeError() {
        Message.removeErrorFromBlock(this.messageId);
    }

    validate() {
        const blocksToValidate = this.blocksToValidate.filter(block => block.getAttribute('id') !== this.childBlockId);

        let isError = false;

        blocksToValidate.forEach((blockToValidate) => {
            if (isError) {
                return;
            }

            const blockToValidateNom = blockToValidate.querySelector('.js-child-nom');
            const blockToValidatePrenom = blockToValidate.querySelector('.js-child-prenom');
            const blockToValidateDate = blockToValidate.querySelector('.js-child-date');
            const allBlockToValidateFields = [
                blockToValidateNom, blockToValidatePrenom, blockToValidateDate,
            ];

            let canAddError = true;

            [...this.allFields, ...allBlockToValidateFields].forEach((field) => {
                if (!canAddError) {
                    return;
                }

                canAddError = Boolean(field.value);
            });

            if (this.childBlockNom.value.toLowerCase() === blockToValidateNom.value.toLowerCase()
            && this.childBlockPrenom.value.toLowerCase() === blockToValidatePrenom.value.toLowerCase()
            && this.childBlockDate.value.toLowerCase() === blockToValidateDate.value.toLowerCase()) {
                if (!canAddError) {
                    return;
                }

                isError = true;
            }
        });

        return !isError;
    }
}

export default class ChildIndenticalValidatorFactory {
    static create(form, selector, submitButton, options = {}) {
        const validatorsArray = [...form.querySelectorAll(selector)];

        return validatorsArray.map((el) => {
            return new ChildIndenticalValidator(el, submitButton, options || {}, validatorsArray);
        });
    }
}
